const target = process.env.TARGET
const cdnUrl = 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com'

let targetMake = {}
let makes = {}

if (target === 'outaigate') {
  targetMake = {
    isSeller: true,
    text: {
      titleEN: 'outaigate',
      titleKR: 'outaigate'
    },
    images: {
      logoSvg: `${cdnUrl}/image/logo.png`,
      appIcon: `${cdnUrl}/image/favicon.ico`,
      kakaoChannel: `${cdnUrl}/image/img/img_channel_connection_sg.png`
    },
    loadingJson: `static/animation/SG_loading.json`
  }
} else {
  targetMake = {
    isSeller: false,
    text: {
      titleEN: 'cloudgate',
      titleKR: '클라우드게이트'
    },
    images: {
      logoSvg: `${cdnUrl}/image/common/cloudgate_bi_horizontal.svg`,
      appIcon: `${cdnUrl}/image/favicon_cg.png`,
      kakaoChannel: `${cdnUrl}/image/img/img_cg_channel_connection.png`
    },
    loadingJson: `static/animation/CG_loading.json`
  }
}

export default Object.assign(makes, targetMake)



// WEBPACK FOOTER //
// ./src/util/targetMake.js